const sustIndexOverview = [
  {
      "country": "Luxembourg",
      "tier": "Very high",
      "wealth": "580000",
      "devGoal": "77.6",
      "population": "249",
      "co2": "1.21",
      "brics": "",
      "g7": "",
      "im": "IM "
  },
  {
      "country": "Switzerland",
      "tier": "Very high",
      "wealth": "352000",
      "devGoal": "80.5",
      "population": "220",
      "co2": "0.40",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Australia",
      "tier": "High",
      "wealth": "205300",
      "devGoal": "75.9",
      "population": "3",
      "co2": "1.46",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Singapore",
      "tier": "High",
      "wealth": "202500",
      "devGoal": "71.8",
      "population": "7595",
      "co2": "0.78",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "USA",
      "tier": "High",
      "wealth": "198200",
      "devGoal": "75.9",
      "population": "36",
      "co2": "1.30",
      "brics": "",
      "g7": "TRUE",
      "im": "TRUE"
  },
  {
      "country": "Canada",
      "tier": "High",
      "wealth": "145300",
      "devGoal": "78.5",
      "population": "4",
      "co2": "1.33",
      "brics": "",
      "g7": "TRUE",
      "im": "TRUE"
  },
  {
      "country": "New Zealand",
      "tier": "High",
      "wealth": "134600",
      "devGoal": "78.4",
      "population": "19",
      "co2": "0.61",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Austria",
      "tier": "High",
      "wealth": "122500",
      "devGoal": "82.3",
      "population": "109",
      "co2": "0.65",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Malta",
      "tier": "High",
      "wealth": "105000",
      "devGoal": "75.5",
      "population": "1620",
      "co2": "0.31",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "UAE",
      "tier": "High",
      "wealth": "102600",
      "devGoal": "69.7",
      "population": "132",
      "co2": "1.99",
      "brics": "TRUE",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Germany",
      "tier": "High",
      "wealth": "98800",
      "devGoal": "83.4",
      "population": "238",
      "co2": "0.72",
      "brics": "",
      "g7": "TRUE",
      "im": ""
  },
  {
      "country": "UK",
      "tier": "High",
      "wealth": "97300",
      "devGoal": "81.7",
      "population": "277",
      "co2": "0.46",
      "brics": "",
      "g7": "TRUE",
      "im": "TRUE"
  },
  {
      "country": "France",
      "tier": "High",
      "wealth": "88000",
      "devGoal": "82.1",
      "population": "124",
      "co2": "0.39",
      "brics": "",
      "g7": "TRUE",
      "im": ""
  },
  {
      "country": "Japan",
      "tier": "High",
      "wealth": "84500",
      "devGoal": "79.4",
      "population": "345",
      "co2": "0.81",
      "brics": "",
      "g7": "TRUE",
      "im": ""
  },
  {
      "country": "Italy",
      "tier": "High",
      "wealth": "72300",
      "devGoal": "78.8",
      "population": "200",
      "co2": "0.48",
      "brics": "",
      "g7": "TRUE",
      "im": "TRUE"
  },
  {
      "country": "Portugal",
      "tier": "High",
      "wealth": "64100",
      "devGoal": "80.0",
      "population": "113",
      "co2": "0.38",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Spain",
      "tier": "High",
      "wealth": "60400",
      "devGoal": "80.4",
      "population": "95",
      "co2": "0.43",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Greece",
      "tier": "High",
      "wealth": "58800",
      "devGoal": "78.4",
      "population": "83",
      "co2": "0.48",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Saudi Arabia",
      "tier": "High",
      "wealth": "52600",
      "devGoal": "67.7",
      "population": "17",
      "co2": "1.41",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Mauritius",
      "tier": "Middle-high",
      "wealth": "38200",
      "devGoal": "68.0",
      "population": "634",
      "co2": "0.29",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "China",
      "tier": "Middle",
      "wealth": "18400",
      "devGoal": "72.0",
      "population": "150",
      "co2": "0.78",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Russian Federation",
      "tier": "Middle",
      "wealth": "16400",
      "devGoal": "73.8",
      "population": "9",
      "co2": "1.13",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Türkiye",
      "tier": "Middle",
      "wealth": "12500",
      "devGoal": "70.8",
      "population": "110",
      "co2": "0.48",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "South Africa",
      "tier": "Middle",
      "wealth": "11200",
      "devGoal": "64.0",
      "population": "49",
      "co2": "0.66",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Argentina",
      "tier": "Middle",
      "wealth": "10500",
      "devGoal": "73.7",
      "population": "17",
      "co2": "0.33",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Namibia",
      "tier": "Middle",
      "wealth": "10400",
      "devGoal": "64.3",
      "population": "3",
      "co2": "0.15",
      "brics": "",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Brazil",
      "tier": "Middle",
      "wealth": "10200",
      "devGoal": "73.7",
      "population": "26",
      "co2": "0.19",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "India",
      "tier": "Low",
      "wealth": "6600",
      "devGoal": "63.4",
      "population": "473",
      "co2": "0.16",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Egypt",
      "tier": "Low",
      "wealth": "4200",
      "devGoal": "69.6",
      "population": "110",
      "co2": "0.19",
      "brics": "TRUE",
      "g7": "",
      "im": "TRUE"
  },
  {
      "country": "Iran",
      "tier": "Low",
      "wealth": "3800",
      "devGoal": "69.1",
      "population": "54",
      "co2": "0.70",
      "brics": "TRUE",
      "g7": "",
      "im": ""
  },
  {
      "country": "Ethiopia",
      "tier": "Very low",
      "wealth": "1200",
      "devGoal": "54.6",
      "population": "107",
      "co2": "0.01",
      "brics": "TRUE"
  }
];

export { sustIndexOverview };